var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarPlayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2.66669H6C6 2.66669 6 4.66669 8 4.66669C10 4.66669 10 2.66669 10 2.66669H12M12 7.33335V12.9334C12 13.0394 11.9579 13.1412 11.8828 13.2162C11.8078 13.2912 11.7061 13.3334 11.6 13.3334H4.4C4.29391 13.3334 4.19217 13.2912 4.11716 13.2162C4.04214 13.1412 4 13.0394 4 12.9334V7.33335M12 2.66669L14.962 3.85135C15.0605 3.89079 15.1393 3.96772 15.181 4.06524C15.2228 4.16276 15.2241 4.27287 15.1847 4.37135L14.1007 7.08202C14.071 7.15622 14.0197 7.21981 13.9535 7.26461C13.8873 7.30941 13.8093 7.33335 13.7293 7.33335H12M4 2.66669L1.038 3.85135C0.939518 3.89079 0.860733 3.96772 0.818975 4.06524C0.777218 4.16276 0.775907 4.27287 0.815333 4.37135L1.89933 7.08202C1.92904 7.15622 1.98029 7.21981 2.04647 7.26461C2.11266 7.30941 2.19075 7.33335 2.27067 7.33335H4",
    stroke: "#0F5CCD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarPlayers);
export default __webpack_public_path__ + "static/media/sidebar-players.be87fc0a9dbb2327ff1ec5c1928705bb.svg";
export { ForwardRef as ReactComponent };